(ns ui.campaign-banner)

(defn ms-until
  "Calculate milliseconds remaining until end-time."
  [end-time]
  (when end-time
    #?(:clj  (let [now (System/currentTimeMillis)
                   end (.getTime (if (instance? java.util.Date end-time)
                                   end-time
                                   (java.util.Date. end-time)))
                   diff-ms (- end now)]
               (max 0 diff-ms))
       :cljs (let [now (js/Date.)
                   end (js/Date. end-time)
                   diff-ms (- (.getTime end) (.getTime now))]
               (max 0 diff-ms)))))

(defn format-discount-value
  "Formats the discount value for display."
  [campaign]
  (str (int (* (:campaign/discount campaign)
               100))
       "%"))

(defn feature-name
  "Converts feature keyword to readable name."
  [feature-key]
  (case feature-key
    :ai-image "AI images"
    :instagram-connection "Instagram connections"
    :tiktok-post "TikTok posts"
    :youtube-short "YouTube Shorts"
    :social-post "social posts"
    :storage-flat-fee "storage"
    (name feature-key)))

(defn format-countdown
  "Format time remaining as countdown string.
   < 24 hours: shows hours and minutes
   >= 24 hours: shows days and hours"
  [ms]
  (when (and ms (pos? ms))
    (let [total-minutes (/ ms 1000.0 60.0)
          total-hours (/ total-minutes 60.0)
          days (int (/ total-hours 24))
          hours (int (mod total-hours 24))
          minutes (int (mod total-minutes 60))]
      (cond
        (< total-minutes 1) "less than 1 minute"
        (< total-hours 24) (str hours " hours " minutes " minutes")
        :else (str days " days " hours " hours")))))

(defn discount-text
  "\"25% off Instagram connections\": what is discounted, not just how
   much. Two customers read the former \"Get 50% discount\" as a coupon for
   the top-up (brain-43); the discount lowers the daily rate of the
   service."
  [campaign]
  (str (format-discount-value campaign)
       " off"
       (when-let [feature (:campaign/feature campaign)]
         (str " " (feature-name feature)))))

(defn discount-description
  [campaign ms-left]
  [:div {:class ["container" "mx-auto" "flex" "items-center" "justify-center" "gap-3"]}
   [:svg {:class ["w-5" "h-5" "text-green-600" "flex-shrink-0"]
          :fill "none"
          :stroke "currentColor"
          :viewBox "0 0 24 24"}
    [:path {:stroke-linecap "round"
            :stroke-linejoin "round"
            :stroke-width "2"
            :d "M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"}]]
   [:div {:class ["flex" "flex-wrap" "justify-center" "text-sm"]}
    [:div {:class ["font-medium" "text-gray-900" "text-nowrap"]} (:campaign/name campaign)]
    [:div {:class ["text-gray-700" "ml-2" "text-nowrap"]}
     (discount-text campaign)]
    ;; "from your first top-up": the campaign is claimed right before the
    ;; checkout (`:command/claim-campaign`), so the welcome credits of a
    ;; trial are billed at the regular rate. One customer read the former
    ;; "applied automatically" as active on the trial and left (brain-77).
    [:div {:class ["text-gray-500" "ml-2" "text-nowrap"]}
     "applied to your daily rate from your first top-up"]
    (when-let [countdown (format-countdown ms-left)]
      [:span {:class ["font-semibold" "text-gray-900" "ml-1"]}
       (str " - only " countdown " left")])]])

(def panel-css
  ["block" "bg-gradient-to-r" "from-green-50" "to-emerald-50"
   "border-b" "border-green-200" "py-1.5" "px-4"
   "hover:from-green-100" "hover:to-emerald-100"
   "transition-colors" "cursor-pointer"])

(defn panel
  [campaign ms-left]
  [:a {:href "/ui/subscription?source=campaign-banner"
       :class panel-css}
   (discount-description campaign ms-left)])

(def rates-modal-actions
  "Opens the rates modal of the wallet page (`ui.wallet.rates`), where the
   discount shows as a badge next to the struck-through price. Same params
   as the page's own \"See our rates\" link."
  [[:ui/modal-open :modals/subscription-rates-modal {:max-width "sm:max-w-2xl"}]])

(defn rates-button
  "The banner on the wallet page itself. There `panel` links to the page
   the customer is already on, which the router treats as a no-op: the
   click did nothing (brain-43). Opens the rates instead."
  [campaign ms-left]
  [:button {:type "button"
            :class (conj panel-css "w-full")
            :on {:click rates-modal-actions}}
   (discount-description campaign ms-left)])
